import { render, staticRenderFns } from "./MyInsuranceTable.vue?vue&type=template&id=65e4c922"
import script from "./MyInsuranceTable.vue?vue&type=script&lang=js"
export * from "./MyInsuranceTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports